import React, { useRef } from 'react';

type Props = {
  className?: string;
  disabled?: boolean;
};

/**
 * Wrap around a component to keep it scrolled to the bottom. If you're using
 * overflow to have a scroll bar then set the overflow on this class to scroll
 * to the bottom of that scrollbar
 */
export const ScrollToBottom = ({
  className,
  disabled,
  children,
}: React.PropsWithChildren<Props>) => {
  const containerDiv = useRef<HTMLDivElement | null>();

  const setContainerDiv = (e: HTMLDivElement | null) => {
    containerDiv.current = e;
  };

  if (containerDiv.current && !disabled) {
    containerDiv.current.scrollTo({ top: Number.MAX_SAFE_INTEGER, behavior: 'smooth' });
  }

  return (
    <div ref={setContainerDiv} className={className}>
      {children}
    </div>
  );
};
